import formatDate from 'date-fns/format';
import type { VoidFunctionComponent } from 'react';

import { BannerAttention, BannerSize, BannerStyle } from '../../../../typings/enums';
import Banner from '../../generic/Banner';
import { NavigationButton } from '../../generic/Button';

type Params = {
  revisionAnalyzedAt: string;
};

export const AnalyzedWithoutSparkleCard: VoidFunctionComponent<Params> = ({ revisionAnalyzedAt }) => {
  const analyzedDate = new Date(revisionAnalyzedAt);
  const bodyMessage = `This revision was last analyzed on ${formatDate(analyzedDate, 'MM/dd/yyyy')} and its dependencies are not yet included in FOSSA's new dependency database.`;
  const action = (
    <NavigationButton
      type="error"
      size="medium"
      to="https://docs.fossa.com/docs/help/dependencylocks-deprecation"
      openInNewTab
    >
      Learn More
    </NavigationButton>
  );
  return (
    <Banner
      bannerSize={BannerSize.Medium}
      bannerStyle={BannerStyle.High}
      bannerAttention={BannerAttention.Low}
      title="Action required: re-analyze this revision to preserve historical dependency data"
      body={bodyMessage}
      actions={action}
    />
  );
};
